/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon, Button } from '@components/atoms'
import { MainHomeBanner } from '@components/systems'

import { MenuType } from '@redux/index'
import { blueGrey } from '@mui/material/colors'

const HomePage = () => {
	const ContentText = ({ menu }: { menu: MenuType }) => {
		return (
			<View className="contentdataView">
				{menu.name === 'home' ? (
					<>
						<Text category="p2">This is Home page.</Text>
					</>
				) : menu.name === 'test' ? (
					<>
						<Text category="p2">This is Home page.</Text>
					</>
				) : (
					''
				)}
			</View>
		)
	}

	const onUpsOauthLoginClick = () => {
		const url =
			'https://wwwcie.ups.com/security/v1/oauth/authorize?client_id=ZWkEa8Abx9u0F6dWmQ3EqX9tzyhFd0EXstXKgvWpEyE3v9vI&redirect_uri=https%3A%2F%2Fups.ceetool.com%2Fcallback&response_type=code'
		window.open(url, '_blank')
	}

	return (
		<View css={style}>
			<MainHomeBanner />

			<View className="contentOuterView">
				<View className="contentInnerView">
					<View className="menuListView">
						<View className="menuView">
							<View className="menuInnerView">
								<View className="headerView">
									<Icon className="menuIcon" name="home" />
									<Text>배송</Text>
								</View>
								<View className="dataView">
									<View className="dataInnerView">
										<Text category="s1" className="menuTitle" i18n={[]}>
											UPS
										</Text>
										<Button
											variant="contained"
											color="inherit"
											onClick={onUpsOauthLoginClick}
										>
											UPS OAuth Login
										</Button>
									</View>
								</View>
							</View>
						</View>

						<View className="menuView">
							<View className="menuInnerView">
								<View className="headerView">
									<Icon className="menuIcon" name="cog" />
								</View>
								<View className="dataView">
									<Text category="s1" className="menuTitle" i18n={[]}>
										Test
									</Text>
									<ContentText menu={{ id: 'b', name: 'test' }} />
								</View>
							</View>
						</View>
					</View>
				</View>
			</View>
		</View>
	)
}

export default HomePage

const style = css({
	'.contentOuterView': {
		position: 'relative',
		width: '100%',
		height: '100%',
		padding: '2rem',

		'.contentInnerView': {
			width: '100%',
			height: 'fit-content',
			minHeight: 'calc(100vh - 27rem)',

			'.menuListView': {
				display: 'flex',
				justifyContent: 'center',
				width: '100%',
				height: '100%',
				minHeight: 'calc(100vh - 27rem)',

				'.menuView': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '25%',
					height: '100%',
					padding: '0 0.5rem',

					'.menuInnerView': {
						position: 'relative',
						width: '100%',
						height: '100%',
						minHeight: 'calc(100vh - 27rem)',
						background: '#FFF',
						border: '1px solid',
						borderColor: blueGrey['A400'],
						borderRadius: '10px',
						overflow: 'hidden',

						'.headerView': {
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'flex-start',
							width: '100%',
							padding: '0.5rem 1rem',
							background: blueGrey['A400'],
							color: 'white',

							'.menuIcon': {
								marginRight: '0.5rem',
								fontSize: '30px',
								color: 'white',
							},
						},
						'.dataView': {
							padding: '0 0.5rem',
							textAlign: 'left',

							'.menuTitle': {},
							'.contentdataView': {
								wordBreak: 'keep-all',
							},
						},
					},
				},
			},
		},
	},
})
